module.exports = __webpack_public_path__ + "static/media/6-iron.160a56f4.png";